import {
  REG_LOADING_IN_PROGRESS,
  REG_LOADING_COMPLETED,
  REG_LOADING_ERROR,
  REG_UPDATED,
  REG_FILTER,
  REG_RESET_FILTER,
  REG_UPDATE_TOURNAMENT,
  REG_UPDATE_TOURNAMENT_NOGROUP,
} from "../actions";

import {
  current_tournament,
  NOT_REGISTERED,
  REJECTED,
  PENDING,
} from "../utils/constants";

const registrations_reducer = (state, action) => {
  if (action.type === REG_UPDATE_TOURNAMENT) {
    return { ...state, current_tournament: action.payload };
  }

  if (action.type === REG_UPDATE_TOURNAMENT_NOGROUP) {
    return {
      ...state,
      current_tournament: action.payload,
      filter_nogroup: true,
    };
  }

  if (action.type === REG_LOADING_IN_PROGRESS) {
    return { ...state, regInProgress: true };
  }
  if (action.type === REG_LOADING_COMPLETED) {
    // By default on page loading filter players by PENDING status
    if (state.registrations.length === 0 && current_tournament) {
      const regs = action.payload.filter(
        (reg) =>
          reg.tournamentHistory.filter(
            (s) =>
              s.tournamentId === state.current_tournament &&
              s.status === PENDING
          ).length > 0
      );

      return {
        ...state,
        regInProgress: false,
        regCompleted: true,
        registrations: regs,
        allRegistrations: action.payload,
      };
    }

    return {
      ...state,
      regInProgress: false,
      regCompleted: true,
      registrations: action.payload,
      allRegistrations: action.payload,
    };
  }
  if (action.type === REG_FILTER) {
    const filtered_registrations = state.allRegistrations.filter((reg) => {
      if (action.payload.filterState === "NO_AOE2PROFILE") {
        var regExp = /^\d+$/;
        return (
          (reg.aoe2ProfileId === null || !regExp.test(reg.aoe2ProfileId)) &&
          reg.status !== REJECTED
        );
      }

      if (action.payload.filterState === NOT_REGISTERED) {
        if (current_tournament)
          return (
            reg.tournamentHistory.filter(
              (s) => s.tournamentId === current_tournament
            ).length === 0
          );
        else {
          return false;
        }
      }

      if (current_tournament) {
        return (
          reg.tournamentHistory.filter(
            (s) =>
              s.tournamentId === state.current_tournament &&
              s.status === action.payload.filterState
          ).length > 0
        );
      } else {
        return false;
      }
      //return reg.status === action.payload.filterState;
    });
    return {
      ...state,
      registrations: filtered_registrations,
    };
  }
  if (action.type === REG_RESET_FILTER) {
    return {
      ...state,
      registrations: state.allRegistrations,
    };
  }
  if (action.type === REG_LOADING_ERROR) {
    return { ...state, regInProgress: false, regError: true };
  }
  if (action.type === REG_UPDATED) {
    let tempRegistrations = state.registrations.map((registration) => {
      if (registration.userId === action.payload.registration.userId) {
        return { ...action.payload.registration };
      }
      return registration;
    });

    return { ...state, registrations: tempRegistrations };
  }
  throw new Error(`No Matching "${action.type}" - action type`);
};

export default registrations_reducer;
